import { DatePipe } from '@angular/common';
import { Component, ElementRef, Injector, ViewChild } from '@angular/core';
import { Validators } from '@angular/forms';
import { DespesaService, EmpenhoService } from 'administrativo-lib';
import { MovimentoEstoqueService } from 'almoxarifado-lib';
import { CompraService } from 'compra-lib';
import {
  Aliquota, BaseResourceFormComponent, Compra, Contrato, DateFormatPipe, Despesa, DocumentoFiscalInfo, Empenho, EmpenhoResto, Exercicio, ExercicioService, Favorecido, FavorecidoService, FichaExtra,
  FuncaoService, GlobalService, LiquidacaoResto, LiquidacaoRestoDeducaoReinf, LiquidacaoRestoIsencaoReinf, LoginContabil, Mensagem, MovimentoEstoque, OrgaoAssinaturaService, PreLiquidacaoResto, Produto, RetencaoResto, Tabela1Reinf
} from 'eddydata-lib';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DocumentoSubcontratacao } from 'projects/eddydata-lib/src/lib/entidade/contabil/documento-subcontratacao.model';
import { takeUntil } from 'rxjs/operators';
import * as toastr from 'toastr';
import { info, warning } from 'toastr';
import { DocumentoSubcontratacaoService } from '../../documento-subcontratacao/documento-subcontratacao.service';
import { DocumentoFiscalInfoService } from '../../documentos-fiscais/service/documento-fiscal-info.service';
import { DocumentoFiscalService } from '../../documentos-fiscais/service/documento-fiscal.service';
import { EmpenhoRestoService } from '../../empenho-resto/service/empenho-resto.service';
import { FichaExtraService } from '../../ficha-extra/service/ficha-extra.service';
import { PreLiquidacaoRestoService } from '../../pre-liquidacao-resto/service/pre-liquidacao-resto.service';
import { NotaLiquidacaoResto } from '../../relatorio/liquidacao/nota-liquidacao-resto';
import { OrdemPagamentoItemService } from '../../tesouraria/service/ordem-item-pagamento.service';
import { LiquidacaoRestoService } from '../service/liquidacao-resto.service';
import { RetencaoRestoService } from '../service/retencao-resto.service';

declare var $: any;

interface IPreLiquidacaoExtendido extends PreLiquidacaoResto {
  total_preliquidado?: string;
  total_preliquidado_anterior?: string;
  total_empenhado?: string;
  total_anulado?: string;
}

@Component({
  selector: 'app-liquidacao-resto-form',
  templateUrl: './liquidacao-resto-form.component.html',
  styles: [`
    .reinf-isencoes-card { border: 1px solid #dfe5ec; border-radius: 6px; box-shadow: 0 3px 10px rgba(33, 37, 41, 0.06); overflow: hidden; }
    .reinf-isencoes-summary { align-items: center; background: #fbfcfd; display: flex; justify-content: space-between; min-height: 58px; padding: 12px 14px; }
    .reinf-isencoes-title { color: #212529; font-size: 13px; font-weight: 700; line-height: 1.2; }
    .reinf-isencoes-count { color: #6c757d; display: block; font-size: 11px; margin-top: 2px; }
    .reinf-isencoes-open { min-width: 96px; }
    .reinf-isencoes-actions .btn { align-items: center; display: inline-flex; height: 32px; justify-content: center; padding: 0; width: 34px; }
    .reinf-isencoes-modal-toolbar { align-items: center; background: #f8fafc; border-bottom: 1px solid #e5eaf0; color: #495057; display: flex; font-size: 12px; justify-content: space-between; padding: 12px 14px; }
    .reinf-isencoes-empty { color: #6c757d; font-size: 12px; padding: 14px; text-align: center; }
    .reinf-isencoes-table th { background: #fbfcfd; border-top: 0; color: #495057; font-size: 11px; font-weight: 700; text-transform: uppercase; }
    .reinf-isencoes-table td { vertical-align: middle; }
    .reinf-isencoes-type { line-height: 1.25; }
    .reinf-isencoes-code { background: #eef4ff; border: 1px solid #cfe0ff; border-radius: 4px; color: #0d6efd; display: inline-block; font-weight: 700; margin-right: 6px; min-width: 28px; padding: 2px 6px; text-align: center; }
  `]
})
export class LiquidacaoRestoFormComponent extends BaseResourceFormComponent<LiquidacaoResto, LoginContabil> {

  /**
   * Declaração de variáveis
   */
  @ViewChild('numero_empenho') inputField: ElementRef;

  public especie: string;
  public listaUfs: Array<any>;
  public empenhado: number;
  public liquidado: number;
  public pago: number;
  public listaRetencoes: Array<RetencaoResto>;
  public empenhoNumero: number;
  public empenhoAno: number;
  public redirecionar = false;
  public empenho: EmpenhoResto;
  public preliquidacoes: PreLiquidacaoResto[];
  public vincularPre: boolean = false;
  public listaDocumentos: Array<DocumentoFiscalInfo> = new Array<DocumentoFiscalInfo>();
  public listaDocSubcontratacao: DocumentoSubcontratacao[] = [];
  public datepipe: DatePipe;
  public totalCancelado: number;
  public saldo: number;
  public compra: Compra
  public totalPreLiquidado: number = 0;
  public movimentoEstoque: MovimentoEstoque;
  public movimentosPendentes: Array<MovimentoEstoque> = null;
  public despesa: Despesa;
  public vencimento: string;
  public bloquearBotoes: boolean = false;
  public objetoReinfTabela1: any;
  public listaIsencoesReinf: LiquidacaoRestoIsencaoReinf[] = [];
  public listaDeducoesReinf: LiquidacaoRestoDeducaoReinf[] = [];
  private isencaoReinfAntiga: LiquidacaoRestoIsencaoReinf;
  private deducaoReinfAntiga: LiquidacaoRestoDeducaoReinf;
  private contrato: Contrato;
  public tiposIsencaoReinf = [
    { valor: 1, descricao: 'Parcela isenta de 65 anos.' },
    { valor: 2, descricao: 'Diária de viagem.' },
    { valor: 3, descricao: 'Indenização e rescisão de contrato, inclusive PDV e acidentes de trabalho.' },
    { valor: 4, descricao: 'Abono pecuniário.' },
    { valor: 5, descricao: 'Valores pagos a titular ou sócio de ME/EPP, exceto pró-labore, aluguéis e serviços.' },
    { valor: 6, descricao: 'Pensão, aposentadoria ou reforma por moléstia grave ou acidente em serviço.' },
    { valor: 7, descricao: 'Complementação de aposentadoria de contribuições de 01/01/1989 a 31/12/1995.' },
    { valor: 8, descricao: 'Ajuda de custo.' },
    { valor: 10, descricao: 'Juros de mora por atraso no pagamento de remuneração.' },
    { valor: 11, descricao: 'Resgate de previdência complementar por portador de moléstia grave.' },
    { valor: 12, descricao: 'Lucros e dividendos distribuídos nos termos da Lei nº 9.250/1995.' },
    { valor: 99, descricao: 'Outros (especificar).' },
  ];
  public tiposDeducaoReinf = [
    { valor: 1, descricao: 'Previdência oficial.' },
    { valor: 2, descricao: 'Previdência privada.' },
    { valor: 3, descricao: 'Fundo de aposentadoria programada individual (Fapi).' },
    { valor: 4, descricao: 'Fundação de previdência complementar ao servidor público (Funpresp).' },
    { valor: 5, descricao: 'Pensão alimentícia.' },
    { valor: 7, descricao: 'Dependentes.' },
    { valor: 8, descricao: 'Desconto simplificado mensal.' },
  ];
  empenhoOrc: Empenho;

  reinf4000sub: boolean = false;

  /**
   * Construtor com as injeções de dependencias
   */
  constructor(
    protected injector: Injector,
    protected globalService: GlobalService,
    protected funcaoService: FuncaoService,
    protected messageService: MessageService,
    protected empenhoService: EmpenhoRestoService,
    protected retencaoService: RetencaoRestoService,
    protected documentoFiscalService: DocumentoFiscalService,
    protected assinaturaService: OrgaoAssinaturaService,
    protected docFiscalService: DocumentoFiscalInfoService,
    protected docSubcontratacaoService: DocumentoSubcontratacaoService,
    protected preService: PreLiquidacaoRestoService,
    protected liquidacaoService: LiquidacaoRestoService,
    protected ordemItemPagamentoService: OrdemPagamentoItemService,
    protected confirmationService: ConfirmationService,
    protected movimentoEstoqueService: MovimentoEstoqueService,
    protected compraService: CompraService,
    protected fichaExtraService: FichaExtraService,
    protected exercicioService: ExercicioService,
    protected favorecidoServico: FavorecidoService,
    protected tabela1ReinfServico: Tabela1Reinf,
    protected despesaServico: DespesaService,
    private empenhoOrcamentarioService: EmpenhoService
  ) {
    super(new LiquidacaoResto(), injector, LiquidacaoResto.converteJson, liquidacaoService);
  }

  // ========================================================================
  //                        MÉTODOS ABSTRAÍDOS
  // ========================================================================

  protected async podeAlterar(_entidade: LiquidacaoResto): Promise<boolean> {
    return !_entidade.anulacao && !_entidade.anulado_total && this.login.sistema != 'indicador-gestao';
  }

  protected criarCamposForm(): void {
    this.entidadeForm = this.fb.group({
      id: [null],
      parcela: [null, [Validators.required]],
      valor_liquidado: [null, [Validators.required]],
      data_liquidacao: [null, [Validators.required]],
      data_vencimento: [null, [Validators.required]],
      historico: [null, [Validators.required, Validators.minLength(2)]],
      mes: [null],
      documento: [null],
      anulacao: [false, [Validators.required]],
      impresso: [false, [Validators.required]],
      recolhimento_encargo: [false, [Validators.required]],
      empenho: [null, [Validators.required]],
      aux: [null],
      orgao: [this.login.orgao, [Validators.required]],
      exercicio: [this.login.exercicio, [Validators.required]],
      retencoes: [null],
      documento_fiscal_info: [null],
      usuario_cadastro: [this.login.usuario],
      preliquidacao: [null],
      valor_base_ir: [null],
      valor_base_csll: [null],
      valor_base_cofins: [null],
      valor_base_pis: [null],
      patrimonio: [null],
      superavit: [false],
      documento_subcontratacao: [null],
      isencoes_reinf: [null],
      deducoes_reinf: [null]
    });
  }

  protected parametrosExtras(): {} {
    return {
      relations: 'documento_subcontratacao,empenho,empenho.favorecido,empenho.favorecido.tipo,empenho.orgao,exercicio,orgao,orgao.cidade,preliquidacao.empenho,preliquidacao.usuario_cadastro,empenho.contrato.aditamentos,empenho.contrato.prazo,documento_fiscal_info,empenho.compra.rcms.prazo_pagamento,isencoes_reinf,deducoes_reinf'
    };
  }

  protected afterInit(): void {
    this.listaUfs = this.globalService.listaEstados();
    this.inicializaVariavel();
  }

  protected campoFoco(): ElementRef {
    return this.inputField;
  }

  protected async beforeSubmit() {
    try {
      if (!this.entidadeForm.get('empenho').value) {
        throw new Error('Informe o empenho para liquidação');
      }
      if (!this.entidadeForm.get('exercicio').value) {
        throw new Error('Informe o exercício da liquidação');
      }
      if (!this.entidadeForm.get('orgao').value) {
        throw new Error('Informe o órgão da liquidação');
      }
      if (!this.entidadeForm.get('historico').value) {
        throw new Error('Informe o histórico da liquidação');
      }
      if (!this.entidadeForm.get('valor_liquidado').value) {
        throw new Error('Informe o valor da liquidação');
      }
      if (!this.entidadeForm.get('data_liquidacao').value) {
        throw new Error('Informe a data da liquidação');
      }
      if (!this.entidadeForm.get('data_vencimento').value) {
        throw new Error('Informe o vencimento da liquidação');
      }
      if (!this.entidadeForm.get('documento').value && !this.entidadeForm.get('documento_fiscal_info').value) {
        throw new Error('Informe o documento da liquidação');
      }
      if (!this.entidadeForm.get('documento').value && this.entidadeForm.get('documento_fiscal_info').value) {
        this.entidadeForm.get('documento').setValue('-');
      }
      if (this.entidadeForm.get('valor_liquidado').value <= 0) {
        throw new Error('O valor da liquidação deve ser maior que zero');
      }
      const exigeValorBaseIr = await this.exigeValorBaseIr();
      this.validarDeducoesReinf();
      if (!this.possuiDeducoesReinf() && exigeValorBaseIr && !+this.entidadeForm.get('valor_base_ir').value) {
        throw new Error('Informe o valor tributável no campo Base de cálculo IR.');
      }

      if (exigeValorBaseIr && +this.entidadeForm.get('valor_base_ir').value > +this.entidadeForm.get('valor_liquidado').value) {
        throw new Error('O Valor Base IR não pode ser maior que o valor do liquidado');
      }
      this.validarIsencoesReinf();

      this.bloquearBotoes = true;

      const dtLiquidacao: Date = this.entidadeForm.get('data_liquidacao').value;
      if (dtLiquidacao.getFullYear() !== this.login.exercicio.ano) {
        throw new Error('O ano da data da liquidação está diferente do exercício logado');
      }

      const preLiq: IPreLiquidacaoExtendido = this.entidadeForm.get("preliquidacao")?.value;
      const totalPreliquidado: number = preLiq?.id ? (+this.totalPreLiquidado - (+preLiq?.valor_liquidado + +preLiq?.total_anulado)) : this.totalPreLiquidado;
      const saldo_liquidacao = +(+this.empenhado - +this.liquidado - +this.totalCancelado - +totalPreliquidado).toFixed(2) + ((this.entidade.valor_liquidado ? +this.entidade.valor_liquidado : 0) - +this.entidadeForm.get('valor_liquidado').value);
      if (saldo_liquidacao < 0) {
        throw new Error('Não há saldo para continuar a liquidação!');
      }

      if (!await this.validarEntradaAlmoxarifado()) {
        throw new Error(`Não foi encontrado entrada deste empenho no almoxarifado/patrimônio. Favor verificar`);
      }

      const pre: PreLiquidacaoResto = this.entidadeForm.get('preliquidacao').value;
      const data_liquidacao: Date = this.entidadeForm.get('data_liquidacao').value;
      if (pre && new Date(pre.data_liquidacao) > data_liquidacao) {
        throw new Error('A data da liquidação não pode ser superior a data da pré-liquidação!');
      }

      this.entidadeForm.get('mes').setValue(+this.funcaoService.converteDataSQL(dtLiquidacao)?.split('-')?.[1]);
      this.entidadeForm.get('retencoes').setValue(this.listaRetencoes);
      this.entidadeForm.get('isencoes_reinf').setValue(this.isencoesReinfParaSalvar());
      this.entidadeForm.get('deducoes_reinf').setValue(this.deducoesReinfParaSalvar());
      const dataLiquidacao = new DateFormatPipe().transform(this.entidadeForm.get('data_liquidacao').value, []);
      this.entidadeForm.get('mes').setValue(+this.funcaoService.converteDataSQL(this.entidadeForm.get('data_liquidacao').value)?.split('-')?.[1]);

      const validarContratoVencido = await this.validarContratoVencido();
      if (!validarContratoVencido) {
        throw new Error('Contrato vencido!');
      }
    } catch (e) {
      this.bloquearBotoes = false;
      this.funcaoService.acaoErro(e);
      throw e;
    }
  }

  public async exigeValorBaseIr(): Promise<boolean> {
    if (this.despesa) {
      return !!this.despesa.valor_tributavel;
    }

    const empenho: EmpenhoResto = this.entidadeForm?.get('empenho')?.value || this.entidade?.empenho;
    if (!empenho?.subelemento) {
      return false;
    }

    const res = await this.despesaServico.filtrar(1, 1, {
      exercicio_id: this.login.exercicio.id,
      codigo: empenho.subelemento
    }).toPromise();

    this.despesa = res?.content?.[0];
    this.carregarNaturezaReinfDespesa();
    return !!this.despesa?.valor_tributavel;
  }

  public permiteIsencoesReinf(): boolean {
    return !!this.despesa?.isencoes_reinf;
  }

  public permiteDeducoesReinf(): boolean {
    return !!this.despesa?.deducoes_reinf && this.favorecidoPessoaFisica();
  }

  public favorecidoPessoaFisica(): boolean {
    const empenho: EmpenhoResto = this.entidadeForm?.get('empenho')?.value || this.entidade?.empenho;
    return empenho?.favorecido?.tipo?.nome === 'CPF - PESSOA FÍSICA';
  }

  public possuiDeducoesReinf(): boolean {
    return this.totalDeducoesReinf() > 0;
  }

  public possuiCalculoIr(): boolean {
    return this.listaRetencoes?.some((retencao) => {
      return +retencao.base_IR > 0
        || +retencao.valor_IR > 0
        || retencao.ficha?.ir_reinf_4000
        || retencao.ficha?.ficha?.tipo_imposto === 'IR'
        || retencao.ficha?.['tipo_imposto'] === 'IR';
    });
  }

  public bloqueiaDeducoesReinf(): boolean {
    return this.possuiCalculoIr()
      || (this.entidade.parcela == 0 && !!this.entidade.id)
      || !!this.entidadeForm.get('preliquidacao').value;
  }

  public bloqueiaValorBaseIr(): boolean {
    return this.possuiDeducoesReinf()
      || (this.entidade.parcela == 0 && !!this.entidade.id)
      || !!this.entidadeForm.get('preliquidacao').value;
  }

  public atualizarBaseIrPorDeducoesReinf(): void {
    if (!this.possuiDeducoesReinf()) {
      return;
    }
    this.entidadeForm.get('valor_base_ir').setValue(`${this.valorBaseIrPorDeducoesReinf()}`);
  }

  private valorBaseIrPorDeducoesReinf(): number {
    const valorLiquidado = +this.entidadeForm.get('valor_liquidado').value || 0;
    const valorBaseIr = +(valorLiquidado - this.totalDeducoesReinf()).toFixed(2);
    return valorBaseIr >= 0 ? valorBaseIr : 0;
  }

  private carregarNaturezaReinfDespesa() {
    this.objetoReinfTabela1 = this.despesa?.codigo_reinf
      ? this.tabela1ReinfServico.carregarPorCodigo(this.despesa.codigo_reinf, true)
      : null;

    if (!this.despesa?.isencoes_reinf) {
      this.listaIsencoesReinf = [];
    }
    if (!this.despesa?.deducoes_reinf || !this.favorecidoPessoaFisica()) {
      this.listaDeducoesReinf = [];
    }
    this.atualizarBaseIrPorDeducoesReinf();
  }

  public adicionarIsencaoReinf() {
    if (this.listaIsencoesReinf.some(item => item['editavel'])) {
      toastr.warning('Já existe uma isenção em edição, salve ou cancele para adicionar outra.');
      return;
    }

    const isencao = new LiquidacaoRestoIsencaoReinf();
    isencao['editavel'] = true;
    this.listaIsencoesReinf.push(isencao);
  }

  public abrirIsencoesReinf() {
    $('#dlgIsencoesReinf').modal('show');
  }

  public editarIsencaoReinf(isencao: LiquidacaoRestoIsencaoReinf) {
    if (this.listaIsencoesReinf.some(item => item['editavel'])) {
      toastr.warning('Já existe uma isenção em edição, salve ou cancele para editar outra.');
      return;
    }

    this.isencaoReinfAntiga = Object.assign(new LiquidacaoRestoIsencaoReinf(), isencao);
    isencao['editavel'] = true;
  }

  public salvarIsencaoReinf(isencao: LiquidacaoRestoIsencaoReinf) {
    try {
      this.validarIsencaoReinf(isencao);
      isencao['editavel'] = false;
      this.isencaoReinfAntiga = null;
    } catch (e) {
      this.funcaoService.acaoErro(e);
    }
  }

  public cancelarIsencaoReinf(isencao: LiquidacaoRestoIsencaoReinf, index: number) {
    if (isencao.id && this.isencaoReinfAntiga) {
      this.listaIsencoesReinf.splice(index, 1, Object.assign(new LiquidacaoRestoIsencaoReinf(), this.isencaoReinfAntiga));
    } else {
      this.listaIsencoesReinf.splice(index, 1);
    }

    this.isencaoReinfAntiga = null;
  }

  public removerIsencaoReinf(index: number) {
    this.listaIsencoesReinf.splice(index, 1);
  }

  public alterarTipoIsencaoReinf(isencao: LiquidacaoRestoIsencaoReinf) {
    if (+isencao.tipo !== 6) {
      isencao.data_laudo = null;
    }
  }

  public tipoIsencaoReinfPermitido(tipo: number): boolean {
    if (!this.objetoReinfTabela1?.insencao) {
      return false;
    }

    return this.objetoReinfTabela1.insencao.split(';').map((item: string) => +item).includes(+tipo);
  }

  public tiposIsencaoReinfPermitidos() {
    return this.tiposIsencaoReinf.filter(tipo => this.tipoIsencaoReinfPermitido(tipo.valor));
  }

  public descricaoTipoIsencaoReinf(tipo: number): string {
    return this.tiposIsencaoReinf.find(item => item.valor === +tipo)?.descricao || '';
  }

  private validarIsencoesReinf() {
    if (!this.permiteIsencoesReinf()) {
      this.listaIsencoesReinf = [];
      return;
    }

    if (this.listaIsencoesReinf.some(item => item['editavel'])) {
      throw new Error('Salve ou cancele a isenção em edição antes de salvar a liquidação.');
    }

    this.listaIsencoesReinf.forEach(item => this.validarIsencaoReinf(item));

    const totalIsencoes = this.listaIsencoesReinf.reduce((total, item) => total + (+item.valor_isento || 0), 0);
    if (+totalIsencoes.toFixed(2) > +(+this.entidadeForm.get('valor_liquidado').value).toFixed(2)) {
      throw new Error('O total das isenções não pode ser maior que o valor liquidado.');
    }
  }

  private validarIsencaoReinf(isencao: LiquidacaoRestoIsencaoReinf) {
    const tipo = +isencao.tipo;
    const valor = +isencao.valor_isento;

    if (!tipo) {
      throw new Error('Informe o tipo da isenção da EFD-Reinf.');
    }

    if (!valor || valor <= 0) {
      throw new Error('Informe o valor da isenção da EFD-Reinf.');
    }

    if (valor > +this.entidadeForm.get('valor_liquidado').value) {
      throw new Error('O valor da isenção não pode ser maior que o valor liquidado.');
    }

    if (!this.tipoIsencaoReinfPermitido(tipo)) {
      throw new Error('Tipo de isenção não permitido para a Natureza de Rendimento da Reinf.');
    }

    if (tipo == 99) {
      if (!isencao.descricao?.trim()) throw new Error('Descrição/especificação da isenção obrigatória para o tipo 99 - Outros.');

      const descTrimmed = isencao.descricao.trim();
      // Mínimo de 5 caracteres alfabéticos
      const alfabeticos = (descTrimmed.match(/[a-zA-ZÀ-ÿ]/g) || []).length;
      if (alfabeticos < 5) {
        throw new Error(`Descrição dos rendimentos isentos deve conter no mínimo 5 caracteres alfabéticos!`);
      }
      // Sem repetição consecutiva de caracteres especiais
      if (/([^a-zA-ZÀ-ÿ0-9\s])\1+/.test(descTrimmed)) {
        throw new Error(`Descrição dos rendimentos isentos não pode conter repetição consecutiva de caracteres especiais!`);
      }

    } else if (tipo != 99 && (isencao.descricao && isencao.descricao.trim() != '')) {
      throw new Error('Descrição/especificação da isenção só pode ser informado para o tipo 99 - Outros.');
    }

    if (tipo === 6 && !this.dataLaudoIsencaoValida(isencao.data_laudo)) {
      throw new Error('Informe a Data da moléstia grave no laudo válida para isenção do tipo 6.');
    }

    if (tipo !== 6) {
      isencao.data_laudo = null;
    }
  }

  private dataLaudoIsencaoValida(data: string): boolean {
    if (!data || data.indexOf('_') >= 0) {
      return false;
    }

    const partes = data.split('/');
    if (partes.length !== 3) {
      return false;
    }

    const dia = +partes[0];
    const mes = +partes[1];
    const ano = +partes[2];
    const dataObj = new Date(ano, mes - 1, dia);

    return ano >= 1900
      && dataObj.getFullYear() === ano
      && dataObj.getMonth() === mes - 1
      && dataObj.getDate() === dia;
  }

  private isencoesReinfParaSalvar(): LiquidacaoRestoIsencaoReinf[] {
    return this.listaIsencoesReinf.map(item => {
      const isencao = Object.assign(new LiquidacaoRestoIsencaoReinf(), item);
      delete isencao['editavel'];
      return isencao;
    });
  }

  public adicionarDeducaoReinf() {
    if (this.bloqueiaDeducoesReinf()) {
      toastr.warning('Não é possível alterar deduções Reinf após o cálculo do IR ou em liquidação bloqueada.');
      return;
    }
    if (this.listaDeducoesReinf.some(item => item['editavel'])) {
      toastr.warning('Já existe uma dedução em edição, salve ou cancele para adicionar outra.');
      return;
    }

    const deducao = new LiquidacaoRestoDeducaoReinf();
    deducao.previdencia_complementar = false;
    deducao.valor_patrocinador = 0;
    deducao['editavel'] = true;
    this.listaDeducoesReinf.push(deducao);
  }

  public abrirDeducoesReinf() {
    $('#dlgDeducoesReinf').modal('show');
  }

  public editarDeducaoReinf(deducao: LiquidacaoRestoDeducaoReinf) {
    if (this.bloqueiaDeducoesReinf()) {
      toastr.warning('Não é possível alterar deduções Reinf após o cálculo do IR ou em liquidação bloqueada.');
      return;
    }
    if (this.listaDeducoesReinf.some(item => item['editavel'])) {
      toastr.warning('Já existe uma dedução em edição, salve ou cancele para editar outra.');
      return;
    }

    this.deducaoReinfAntiga = Object.assign(new LiquidacaoRestoDeducaoReinf(), deducao);
    deducao.valor_patrocinador = +deducao.valor_patrocinador || 0;
    deducao['editavel'] = true;
  }

  public salvarDeducaoReinf(deducao: LiquidacaoRestoDeducaoReinf) {
    try {
      this.validarDeducaoReinf(deducao);
      deducao['editavel'] = false;
      this.deducaoReinfAntiga = null;
      this.atualizarBaseIrPorDeducoesReinf();
    } catch (e) {
      this.funcaoService.acaoErro(e);
    }
  }

  public cancelarDeducaoReinf(deducao: LiquidacaoRestoDeducaoReinf, index: number) {
    if (deducao.id && this.deducaoReinfAntiga) {
      this.listaDeducoesReinf.splice(index, 1, Object.assign(new LiquidacaoRestoDeducaoReinf(), this.deducaoReinfAntiga));
    } else {
      this.listaDeducoesReinf.splice(index, 1);
    }

    this.deducaoReinfAntiga = null;
    this.atualizarBaseIrPorDeducoesReinf();
  }

  public removerDeducaoReinf(index: number) {
    if (this.bloqueiaDeducoesReinf()) {
      toastr.warning('Não é possível alterar deduções Reinf após o cálculo do IR ou em liquidação bloqueada.');
      return;
    }
    this.listaDeducoesReinf.splice(index, 1);
    this.atualizarBaseIrPorDeducoesReinf();
  }

  public alterarTipoDeducaoReinf(deducao: LiquidacaoRestoDeducaoReinf) {
    if (![2, 3, 4].includes(+deducao.tipo)) {
      deducao.previdencia_complementar = false;
      deducao.cnpj_previdencia_complementar = null;
    }
    if (+deducao.tipo !== 4) {
      deducao.valor_patrocinador = 0;
    }
  }

  public tipoDeducaoReinfPermitido(tipo: number): boolean {
    if (!this.objetoReinfTabela1?.ded) {
      return false;
    }

    return this.objetoReinfTabela1.ded.split(';').map((item: string) => +item).includes(+tipo);
  }

  public tiposDeducaoReinfPermitidos() {
    return this.tiposDeducaoReinf.filter(tipo => this.tipoDeducaoReinfPermitido(tipo.valor));
  }

  public descricaoTipoDeducaoReinf(tipo: number): string {
    return this.tiposDeducaoReinf.find(item => item.valor === +tipo)?.descricao || '';
  }

  public totalDeducoesReinf(): number {
    return +(this.listaDeducoesReinf || []).reduce((total, item) => total + (+item.valor_deducao || 0), 0).toFixed(2);
  }

  private validarDeducoesReinf() {
    if (!this.permiteDeducoesReinf()) {
      this.listaDeducoesReinf = [];
      return;
    }

    if (this.listaDeducoesReinf.some(item => item['editavel'])) {
      throw new Error('Salve ou cancele a dedução em edição antes de salvar a liquidação.');
    }

    this.listaDeducoesReinf.forEach(item => this.validarDeducaoReinf(item));
    this.validarCnpjPrevidenciaComplementarDuplicado();

    const totalDeducoes = this.totalDeducoesReinf();
    if (+totalDeducoes.toFixed(2) > +(+this.entidadeForm.get('valor_liquidado').value).toFixed(2)) {
      throw new Error('O total das deduções não pode ser maior que o valor liquidado.');
    }

    this.atualizarBaseIrPorDeducoesReinf();
  }

  private validarDeducaoReinf(deducao: LiquidacaoRestoDeducaoReinf) {
    const tipo = +deducao.tipo;
    const valor = +deducao.valor_deducao;

    if (!tipo) {
      throw new Error('Informe o tipo da dedução da EFD-Reinf.');
    }

    if (!valor || valor <= 0) {
      throw new Error('Informe o valor da dedução da EFD-Reinf.');
    }

    if (valor > +this.entidadeForm.get('valor_liquidado').value) {
      throw new Error('O valor da dedução não pode ser maior que o valor liquidado.');
    }

    if (!this.tipoDeducaoReinfPermitido(tipo)) {
      throw new Error('Tipo de dedução não permitido para a Natureza de Rendimento da Reinf.');
    }

    if ([2, 3, 4].includes(tipo) && deducao.previdencia_complementar && !this.cnpjPrevidenciaValido(deducao.cnpj_previdencia_complementar)) {
      throw new Error('Informe um CNPJ válido para a entidade de previdência complementar.');
    }

    deducao.valor_patrocinador = +deducao.valor_patrocinador || 0;
    this.alterarTipoDeducaoReinf(deducao);
  }

  private validarCnpjPrevidenciaComplementarDuplicado(): void {
    const chaves = new Set<string>();
    for (const deducao of this.listaDeducoesReinf) {
      if (!deducao.previdencia_complementar || ![2, 3, 4].includes(+deducao.tipo)) {
        continue;
      }
      const cnpj = String(deducao.cnpj_previdencia_complementar || '').replace(/\D/g, '');
      const chave = `${deducao.tipo}-${cnpj}`;
      if (chaves.has(chave)) {
        throw new Error('O CNPJ da previdência complementar não pode ser repetido para o mesmo tipo de dedução.');
      }
      chaves.add(chave);
    }
  }

  private cnpjPrevidenciaValido(cnpj: string): boolean {
    const valor = String(cnpj || '').replace(/\D/g, '');
    return valor.length === 14 && !/^(\d)\1+$/.test(valor);
  }

  private deducoesReinfParaSalvar(): LiquidacaoRestoDeducaoReinf[] {
    return this.listaDeducoesReinf.map(item => {
      const deducao = Object.assign(new LiquidacaoRestoDeducaoReinf(), item);
      deducao.valor_patrocinador = +deducao.valor_patrocinador || 0;
      delete deducao['editavel'];
      return deducao;
    });
  }

  protected async afterSubmit(ent: LiquidacaoResto) {
    this.bloquearBotoes = false;
    if (this.currentActionRoute === 'novo') {
      if (this.movimentoEstoque?.id) {
        await this.movimentoEstoqueService.vincularNovaLiquidacao(this.movimentoEstoque.id, ent.id, 'R').toPromise();
      }
      if (this.login.redirecionar_liquidar_pagar && this.podeIncluir('/pagamentos-resto')) {
        this.router.navigate(['/pagamentos-resto', 'novo', ent.id]);
      } else if (!this.limparTela) {
        this.router.navigate(['/liquidacoes-restos-pagar', ent.id, 'editar']);
      } else {
        this.router.navigate(['/liquidacoes-restos-pagar', 'novo']);
      }
      this.skipRedirect = false;
    } else {
      this.router.navigate(['/liquidacoes-restos-pagar', ent.id, 'editar']).then(() => {
        this.obterRetencoes(ent.id);
      });
    }
  }

  public naturezaRendimento(item: Produto) {
    const obj = this.tabela1ReinfServico.carregarPorCodigo(item?.codigo_reinf != null ? item?.codigo_reinf : item.material?.codigo_reinf != null ? item.material?.codigo_reinf : this.despesa?.codigo_reinf, true);

    return obj?.codigo + ' - ' + (obj?.nome.length < 30 ? obj?.nome : obj?.nome.substring(0, 30) + '...');
  }

  protected async afterLoad() {
    if (!this.podeAlterarAudesp(this.entidade.data_liquidacao)) {
      this.router.navigate(['/liquidacoes-restos-pagar']);
      warning('Não é possível alterar. Prazo esgotado!');
      return;
    }

    this.calcularPrazo(this.entidade.empenho);

    if (this.entidade.id) {
      this.obterRetencoes(this.entidade.id);
      this.exigeValorBaseIr()
      this.empenhoNumero = this.entidade.empenho.numero;
      this.empenhoAno = this.entidade.empenho.ano;
      if (this.empenhoOrc == null) {
        this.empenhoOrcamentarioService.obter({
          'orgao.id': this.login.orgao.id,
          ignoreCondObrig: true,
          'exercicio.ano': this.empenhoAno,
          numero: this.empenhoNumero,
          relations: 'contrato',
          'favorecido.id': this.entidade.empenho.favorecido.id
        }).subscribe({
          next: (res) => {
            this.empenhoOrc = res;
          }
        });
      }
      this.entidade.data_liquidacao = new DateFormatPipe().transform(this.entidade.data_liquidacao, []);
      this.entidade.data_vencimento = new DateFormatPipe().transform(this.entidade.data_vencimento, []);
      this.empenho = this.entidade.empenho;
      this.reinf4000sub = this.entidade.empenho.favorecido.repasse_pagamento_reinf;
      if (!this.reinf4000sub) {
        await this.carregarDocumentosFiscais();
      } else {
        await this.carregarDocumentosSubcontratacao();
      }
      this.listaIsencoesReinf = (this.entidade.isencoes_reinf || []).map(item => Object.assign(new LiquidacaoRestoIsencaoReinf(), item));
      this.listaDeducoesReinf = (this.entidade.deducoes_reinf || []).map(item => {
        const deducao = Object.assign(new LiquidacaoRestoDeducaoReinf(), item);
        deducao.valor_patrocinador = +deducao.valor_patrocinador || 0;
        return deducao;
      });
      this.movimentoEstoqueService.filtrar(0, -1, {
        relations: 'itens,compra,compra.exercicio,compra.contrato,tipo,recebedor,itens.produto_unidade,itens.produto_unidade.produto,itens.produto_unidade.produto.material,itens.produto_unidade.unidade',
        'liquidacao_resto.id': this.entidade.id, excluido: false, 'orgao.id': this.login.orgao.id
      }).pipe(takeUntil(this.unsubscribe)).subscribe({
        next: (res) => {
          if (res?.content?.length > 0) {
            this.movimentoEstoque = res.content[0];
          } else {
            // if (this.entidade.empenho?.subelemento?.codigo_reinf) {
            // this.objetoReinfTabela1 = this.tabela1ReinfServico.carregarPorCodigo(this.entidade.empenho.subelemento.codigo_reinf, true);
            // }
          }
        }, error: (e) => { this.messageService.add({ severity: 'error', summary: 'Atenção', detail: e.error.payload }) }
      });

      this.despesaServico.filtrar(1, -1, { exercicio_id: this.login.exercicio.id, codigo: this.entidade.empenho.subelemento }).pipe(takeUntil(this.unsubscribe))
        .subscribe(res => {
          this.despesa = res.content[0];
          this.carregarNaturezaReinfDespesa();
          this.atualizarBaseIrPorDeducoesReinf();
        });
    }
  }

  private obterRetencoes(id: number) {
    this.loadTotalizadores().then(() => {
      this.retencaoService.obterPorLiquidacao(id).pipe(takeUntil(this.unsubscribe))
        .subscribe(
          (data: any) => {
            this.listaRetencoes = data ? data.content : new Array<RetencaoResto>();
            this.listaRetencoes.forEach(async ret => this.editarRetencaoOrcamentaria(ret) && this.editarRetencaoExtra(ret))
          }, e => this.messageService.add({ severity: 'error', summary: 'Atenção', detail: e })
        );
    });
  }

  public async editarRetencaoOrcamentaria(item: RetencaoResto) {
    if (item.id) {
      let ordemPagamento = await this.ordemItemPagamentoService.obter({ liquidacao_resto_id: this.entidade.id }).toPromise();
      if (!item.liquidacao?.pagamentos?.length && !ordemPagamento) {
        item['sem_escrituracao'] = true;
      } else {
        for (const pag of item.liquidacao.pagamentos) {
          if ((pag.anulacao || pag.anulado_total) && !ordemPagamento) {
            item['sem_escrituracao'] = true;
          } else {
            item['sem_escrituracao'] = false;
          }
        }
      }
    } else {
      item['sem_escrituracao'] = false;
    }
  }

  public async editarRetencaoExtra(item: RetencaoResto) {
    if (item.id && !item.ficha.enviar_efd_reinf) {
      item['nao_enviar_reinf'] = true;
    } else {
      item['nao_enviar_reinf'] = false;
    }

  }

  // ========================================================================
  //                            MÉTODOS DA CLASSE
  // ========================================================================

  private inicializaVariavel() {
    if (this.currentActionRoute === 'novo') {
      this.listaRetencoes = new Array<RetencaoResto>();

      this.liquidacaoService.ultimaDataLiquidada(this.login.exercicio.id, this.login.orgao.id)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe((dataLiq) => {
          if (dataLiq === 0) {
            this.entidade.data_liquidacao = new Date();
          } else {
            this.entidade.data_liquidacao = new DateFormatPipe().transform(dataLiq, []);
          }
          this.entidadeForm.get('data_liquidacao').setValue(this.entidade.data_liquidacao);
          this.entidadeForm.get('mes').setValue(+this.funcaoService.converteDataSQL(this.entidade.data_liquidacao)?.split('-')?.[1]);
        });

      if (this.login?.liquidacao_vencimento_30_dias) {
        this.entidadeForm.get('data_vencimento').setValue(this.funcaoService.adicionarDia(30, new Date()));
      }


      this.activatedRoute.params.pipe(takeUntil(this.unsubscribe))
        .subscribe(
          (params: any) => {
            if (params.hasOwnProperty('empenho')) {
              const parametros = {};
              parametros['id'] = params['empenho'];
              parametros['relations'] = 'favorecido,favorecido.tipo,compra,contrato.aditamentos,contrato.prazo,compra.rcms.prazo_pagamento,licitacao,modalidade,convenio,orgao';
              this.empenhoService.obter(parametros)
                .pipe(takeUntil(this.unsubscribe))
                .subscribe(
                  (entidade) => {
                    this.redirecionar = true;
                    this.empenhoNumero = entidade.numero;
                    this.empenhoAno = entidade.ano;
                    this.entidadeForm.get('empenho').setValue(entidade);
                    this.entidadeForm.get('historico').setValue(entidade.historico);
                    if (!this.login?.liquidacao_vencimento_30_dias) {
                      this.entidadeForm.get('data_vencimento').setValue(new DateFormatPipe().transform(entidade.data_vencimento, []));
                    }
                    this.entidade.empenho = entidade;
                    this.atualizarBaseIrPorDeducoesReinf();
                    this.calcularPrazo(entidade);
                    this.exigeValorBaseIr();
                    if (this.entidade.empenho) {
                      this.loadTotalizadores();
                      this.obterUltimaParcela();
                    }
                  }, () => this.sair());
            }
          });
    }
  }

  public resetarValorFiscal() {
    if (this.entidadeForm.get('documento_fiscal_info').value === 'null') {
      this.entidadeForm.get('documento_fiscal_info').setValue(null)
    }
  }

  private carregarDocumentosSubcontratacao(edicao?: boolean) {
    const favorecido = (this.entidade.id ? this.entidade.empenho.favorecido
      : this.entidadeForm.get('empenho').value ? this.entidadeForm.get('empenho').value['favorecido'] : null);
    if (!favorecido) return;

    const params = {};
    params['favorecido.id'] = favorecido.id;
    const vencimento: Date = this.entidade.id && !edicao ? this.entidade.data_vencimento : this.entidadeForm.get('data_vencimento').value;
    let data: Date = this.entidade.id && !edicao ? this.entidade.data_liquidacao : this.entidadeForm.get('data_liquidacao').value;
    if (data) {
      data = new Date(data.getFullYear(), data.getMonth() - (data.getMonth() == 1 ? 1 : 2), 1, 0, 0, 0);
    }
    if (vencimento && data) {
      params['data_emissao$ge'] = this.datepipe.transform(data, 'yyyy-MM-dd');
      params['data_emissao$le'] = this.datepipe.transform(vencimento, 'yyyy-MM-dd');
    }

    params['ignoreCondObrig'] = true;
    if (vencimento && favorecido) {
      this.docSubcontratacaoService.filtrar(0, -1, params).pipe(takeUntil(this.unsubscribe)).subscribe((res) => {
        this.listaDocSubcontratacao = res.content;
      });
    }

    this.calcularPrazo(this.entidade.empenho);
  }

  public async carregarDocumentosFiscais(edicao?: boolean) {
    this.datepipe = new DatePipe('pt');
    const params = {};

    params['documento_fiscal.orgao.id'] = this.login.orgao.id;
    params['relations'] = 'documento_fiscal';
    const favorecido = (this.entidade.id ? this.entidade.empenho.favorecido
      : this.entidadeForm.get('empenho').value ? this.entidadeForm.get('empenho').value['favorecido'] : null);
    if (!favorecido) return;

    params['documento_fiscal.favorecido.id'] = favorecido.id
    const vencimento: Date = this.entidade.id && !edicao ? this.entidade.data_vencimento : this.entidadeForm.get('data_vencimento').value;
    let data: Date = this.entidade.id && !edicao ? this.entidade.data_liquidacao : this.entidadeForm.get('data_liquidacao').value;
    if (data) {
      data = new Date(data.getFullYear(), data.getMonth() - (data.getMonth() == 1 ? 1 : 2), 1, 0, 0, 0);
    }

    if (vencimento && data) {
      params['documento_fiscal.data_emissao$ge'] = this.datepipe.transform(data, 'yyyy-MM-dd');
      params['documento_fiscal.data_emissao$le'] = this.datepipe.transform(vencimento, 'yyyy-MM-dd');
    }

    if (vencimento && favorecido) {
      this.listaDocumentos = (await this.docFiscalService.filtrar(0, -1, params).toPromise()).content;
    }

    this.calcularPrazo(this.entidade.empenho);
  }

  public async atualizarEmpenho() {
    if (this.empenhoNumero > 0 && this.empenhoAno && !this.entidade.id) {
      const param = {};
      param['numero'] = this.empenhoNumero;
      param['ano'] = this.empenhoAno;
      param['orgao.id'] = this.login.orgao.id;
      param['exercicio_id'] = this.login.exercicio.id;
      param['relations'] = 'favorecido,favorecido.tipo,favorecido.cidade,contrato,contrato.aditamentos,contrato.prazo,compra.rcms.prazo_pagamento';
      this.entidade.empenho = await this.empenhoService.obter(param).pipe(takeUntil(this.unsubscribe)).toPromise();
      this.despesa = null;
      this.contrato = this.entidade.empenho.contrato;
      await this.exigeValorBaseIr();
      if (!this.entidade.empenho) {
        Mensagem.alerta(this.messageService, 'Empenho não localizado!');
        this.entidadeForm.get('empenho').setValue(null);
        this.loadTotalizadores();
        return;
      }

      if (!await this.validarEntradaAlmoxarifado()) {
        this.messageService.add({ severity: 'warn', summary: 'Erro', detail: `Não foi encontrado entrada deste empenho no almoxarifado/patrimônio. Favor verificar.` });
        this.entidadeForm.get('empenho').setValue(null);
        this.loadTotalizadores();
      }

      if (this.entidade.empenho) {
        this.loadTotalizadores();
        this.obterUltimaParcela();
        this.calcularPrazo(this.entidade.empenho);

        if (!this.entidadeForm.get('data_liquidacao').value) {
          this.entidadeForm.get('data_liquidacao').setValue(new Date());
        }

        this.entidadeForm.get('empenho').setValue(this.entidade.empenho);
        this.atualizarBaseIrPorDeducoesReinf();
        if (!this.login?.liquidacao_vencimento_30_dias) {
          this.entidadeForm.get('data_vencimento').setValue(new DateFormatPipe().transform(this.entidade.empenho.data_vencimento, []));
        }
        this.entidadeForm.get('historico').setValue(this.entidade.empenho.historico);
        this.entidadeForm.get('mes').setValue(+this.funcaoService.converteDataSQL(this.entidade.data_liquidacao)?.split('-')?.[1]);
        this.reinf4000sub = this.entidade.empenho.favorecido.repasse_pagamento_reinf;
      }

      //Verifica vinculo com o compras
      if (this.entidade.empenho.compra) {
        this.movimentoEstoqueService.filtrar(0, -1, {
          relations: 'itens,compra,compra.exercicio,compra.contrato,tipo,recebedor,itens.produto_unidade,'
            + 'itens.produto_unidade.produto,itens.produto_unidade.produto.material,itens.produto_unidade.unidade',
          excluido: false, 'orgao.id': this.login.orgao.id, desvinculado_liquidacao: true,
          'compra.id': this.entidade.empenho.compra.id
        }).pipe(takeUntil(this.unsubscribe)).subscribe({
          next: (res) => {
            this.movimentosPendentes = res.content;
            if (this.movimentosPendentes.length > 0) {
              $('#dlgMovimento').modal('show');
            }
          }, error: (e) => {
            warning(`Erro ao procurar pendências de movimentação!`)
          }
        });
      }

      if (this.entidade?.empenho?.favorecido?.tipo.tce === '01' &&
        (this.login.parametro['contabil'].utilizar_aliquota_ir
          || this.login.parametro['contabil'].utilizar_aliquota_cofins
          || this.login.parametro['contabil'].utilizar_aliquota_csll
          || this.login.parametro['contabil'].utilizar_aliquota_pis_pasep)) {
        if (!this.entidade.empenho.favorecido.conferencia_simples) {//Se nunca foi validado, obrigatóriamente tem que fazer a primeira validação.
          $('#dlgSimplesNacional').modal('show');
        } else if (this.entidade.empenho.favorecido.simples_nacional) {
          //Se forem simples, e a ultima validação for antes de janeiro do ano, 
          if (this.entidade.empenho.favorecido.conferencia_simples < new Date(this.login.exercicio.ano, 1, 1, 0, 0, 0)) {
            $('#dlgSimplesNacional').modal('show');
          }
        }
      }
    }
  }

  public calcularPrazo(empenho: EmpenhoResto) {
    if (empenho?.contrato && empenho?.contrato?.prazo) {
      this.vencimento = empenho.contrato.prazo.nome;
    } else if (empenho?.compra?.rcms && empenho?.compra?.rcms?.prazo_pagamento) {
      this.vencimento = empenho.compra.rcms.prazo_pagamento.nome;
    } else {
      this.vencimento = 'À VISTA';
    }
  }

  public vincularMovimento(movimento: MovimentoEstoque) {
    movimento.desvinculado_liquidacao = false;
    this.movimentoEstoque = movimento;
    this.entidadeForm.get('valor_liquidado').setValue('' + this.saldoTotalMovimento());
    this.entidade.valor_liquidado = this.saldoTotalMovimento();
    this.atualizarBaseIrPorDeducoesReinf();
    this.verificarValorLiquidado();
    this.verificarParcela();
    $('#dlgMovimento').modal('hide');
  }

  public quantidadeTotalMovimento() {
    let valor = 0;
    if (this.movimentoEstoque.itens)
      for (let item of this.movimentoEstoque.itens) {
        valor += item.qtde ? parseFloat(item.qtde.toString()) : 0;
      }
    return valor;
  }

  public saldoTotalMovimento() {
    let valor = 0;
    if (this.movimentoEstoque.itens)
      for (let item of this.movimentoEstoque.itens) {
        let valor_unitario = item.valor_unitario ? parseFloat(item.valor_unitario.toString()) : 0;
        let qtde = item.qtde ? parseFloat(item.qtde.toString()) : 0;
        valor += valor_unitario * qtde;
      }
    return valor;
  }

  async atualizarSimples(simples: boolean) {
    const fav: Favorecido = this.entidade.empenho.favorecido;
    fav.simples_nacional = simples;
    fav.conferencia_simples = new Date();
    await this.favorecidoServico.atualizar(fav).toPromise();
    this.entidade.empenho.favorecido = fav;
  }

  public async validarEntradaAlmoxarifado() {
    if (this.login.verificar_liquidacao_estoque) {
      if (this.entidade.empenho.subelemento.substring(4, 6) === '30' || this.entidade.empenho.subelemento.substring(4, 6) === '52') {
        const movimento = await this.movimentoEstoqueService.obter({ excluido: false, 'orgao.id': this.login.orgao.id, compra_id: this.entidade.empenho.compra ? this.entidade.empenho.compra.id : 0 }).pipe(takeUntil(this.unsubscribe)).toPromise();
        if (!movimento) {
          return false;
        }
      }
    }
    return true;
  }

  // private async confirmarValorPre() {
  // if (!this.entidade.id && +this.entidadeForm.get('valor_liquidado').value !== this.saldo) {
  //   return new Promise((resolve, reject) => {
  //     this.confirmationService.confirm({
  //       header: 'Atenção!',
  //       message:
  //         `O valor liquidado será alterado. Deseja realizar essa alteração?`,
  //       accept: () => {
  //         resolve(true);
  //       },
  //       reject: () => {
  //         resolve(false);
  //       }
  //     });
  //   });
  // }
  // }

  /* Se o usuario informou um valor diferente do empenhado
   * atribui a parcela como sendo a primeira
   */
  public verificarParcela() {
    if (+(+this.empenhado - +this.liquidado).toFixed(2) + ((this.entidade.valor_liquidado ? +this.entidade.valor_liquidado : 0) - +this.entidadeForm.get('valor_liquidado').value) < 0) {
      Mensagem.alerta(this.messageService, 'Não há saldo disponível para esta liquidação!');
    } else {
      this.atualizarBaseIrPorDeducoesReinf();
      this.obterUltimaParcela();
    }
  }

  public async verificarValorLiquidado() {
    if (+(+this.empenhado - +this.liquidado).toFixed(2) + ((this.entidade.valor_liquidado ? +this.entidade.valor_liquidado : 0) - +this.entidadeForm.get('valor_liquidado').value) < 0) {
      return;
    }
    this.atualizarBaseIrPorDeducoesReinf();
  }

  public abrirDocsFiscais() {
    const param = {};
    if (this.entidade?.empenho?.contrato && this.entidade.empenho.contrato?.tipo_contratacao?.exige_cno && !this.reinf4000sub) {
      param['tipo'] = 'C';
      param['id'] = this.entidade.empenho.contrato.id;
    } else {
      param['tipo'] = 'F';
      param['id'] = this.entidade.empenho.favorecido.id;
    }
    param['doc'] = this.entidadeForm.get('documento').value;

    let favorecido = this.entidade.empenho.favorecido

    this.documentoFiscalService.filtrar(1, 1, { 'orgao.id': this.login.orgao.id, 'numero_documento': this.entidadeForm.get('documento').value, 'favorecido.cpf_cnpj': favorecido.cpf_cnpj }).subscribe(async e => {
      if (e.content?.length > 0) {
        const text = `Número de documento ${this.entidadeForm.get('documento').value} existente para o CNPJ informado!'`;
        info(text, 'Validação');
      } else {
        const path: string = this.reinf4000sub ? 'documentos-subcontratacoes' : 'documentos-fiscais'
        const url = this.router.createUrlTree([`/${path}/novo/${param['tipo']}/${param['id']}/${param['doc']}`]);
        window.open('#/' + url.toString(), '_blank');
      }
    });
  }

  private async obterUltimaParcela() {
    this.liquidacaoService.obterUltimaParcela(
      this.entidade.empenho.numero, this.login.exercicio.id, this.login.orgao.id, this.entidade.empenho.ano
    ).pipe(takeUntil(this.unsubscribe))
      .subscribe(
        (res: any) => {
          this.entidade.parcela = res;
          if (!this.entidade.id) {
            if (+this.empenhado > +this.entidadeForm.get('valor_liquidado').value && res == 0) {
              res = 1;
            } else {
              if (+res > 0) {
                res = +res + 1;
              }
            }
            this.entidade.parcela = res;
            this.entidadeForm.get('parcela').setValue(res);
            if (!this.vincularPre)
              this.obterPreLiquidacao(this.entidade.empenho);
          }
        }, e => this.messageService.add({ severity: 'error', summary: 'Atenção', detail: e })
      );
  }

  public async obterPreLiquidacao(empenho: EmpenhoResto) {
    const param = {};
    param['empenho_id'] = empenho.id;
    param['exercicio.id'] = this.login.exercicio.id;
    param['orgao.id'] = this.login.orgao.id;
    param['liquidacoes.id$null'] = '';
    param['anulacao'] = false;
    param['anulado_total'] = false;
    param['orderBy'] = 'id$ASC';
    param['relations'] = 'usuario_cadastro,empenho,liquidacoes';

    const pre = await this.preService.extendido(1, -1, param).toPromise();
    const encontrouPre = this.getVinculoPreLiquidacao(pre.content);
    this.preliquidacoes = pre.content;
  }


  public selecionarPre(pre: PreLiquidacaoResto): void {
    this.entidadeForm.get('preliquidacao').setValue(pre);
    const anulado = pre['total_anulado'] ? +pre['total_anulado'] : 0;
    const valor_liquidado = +pre.valor_liquidado + anulado;
    this.entidadeForm.get('valor_liquidado').setValue(valor_liquidado.toString());
    this.verificarParcela();
    // this.entidadeForm.get('data_vencimento').setValue(new DateFormatPipe().transform(pre.data_vencimento, []));
    this.entidadeForm.get('historico').setValue(pre.historico);
    this.entidadeForm.get('documento').setValue(pre.documento);
    this.vincularPre = true;

    $('#dlgconsultaPreLiquidacaoResto').modal('hide');
  }

  private async loadTotalizadores() {
    this.empenhado = 0;
    this.liquidado = 0;
    this.pago = 0;
    this.totalCancelado = 0;

    if (!this.entidade.empenho) {
      return;
    }

    let totalizadores = await this.empenhoService.totalizadores(
      this.entidade.empenho.ano,
      this.entidade.empenho.orgao.id,
      this.login.exercicio.id,
      this.entidade.empenho.id, this.entidade?.preliquidacao?.id).toPromise();

    if (totalizadores) {
      totalizadores = totalizadores.content[0] ? totalizadores.content[0] : totalizadores.content;
      this.empenhado = totalizadores.total_empenhado;
      this.liquidado = totalizadores.total_liquidado;
      this.pago = totalizadores.total_pago;
      this.totalCancelado = +totalizadores.total_cancelado_nao_processado + +totalizadores.total_cancelado_processado;
      this.totalPreLiquidado = totalizadores.total_preliquidado_aberto;
    }

    if (!this.entidadeForm.get('id').value) {
      const preLiq: IPreLiquidacaoExtendido = this.entidadeForm.get("preliquidacao")?.value;
      const totalPreliquidado: number = preLiq?.id ? (+this.totalPreLiquidado - (+preLiq?.valor_liquidado + +preLiq?.total_anulado)) : this.totalPreLiquidado;
      const saldo = +(+this.empenhado - +this.liquidado - +this.totalCancelado - +totalPreliquidado).toFixed(2);
      this.saldo = saldo;
      this.entidadeForm.get('valor_liquidado').setValue(saldo.toString());
      if (saldo <= 0 && +totalPreliquidado > 0) {
        warning('Não há saldo para realizar essa liquidação sem vinculo com alguma pré liquidação!');
        return;
      }
      if (saldo <= 0) {
        Mensagem.alerta(this.messageService, 'Não há saldo disponível para esta liquidação!');
      }
    }
  }

  public imprimir() {
    const parametros = {};
    parametros['relations'] = 'empenho,empenho.contrato,empenho.favorecido,empenho.licitacao,empenho.modalidade,empenho.compra,empenho.compra.rcms,empenho.favorecido.contas.orgao,empenho.favorecido.contas.banco,documento_fiscal_info,documento_fiscal_info.documento_fiscal';
    parametros['exercicio_id'] = this.login.exercicio.id;
    parametros['orgao_id'] = this.login.orgao.id;
    parametros['id'] = this.entidade.id;
    this.liquidacaoService
      .extendido(1, -1, parametros)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(lista => {
        this.assinaturaService.obter()
        new NotaLiquidacaoResto(this.assinaturaService).imprimir(lista.content, this.login);
      },
        (e) => this.messageService.add(
          { severity: 'error', summary: 'Atenção!', detail: e.error && e.error.payload ? e.error.payload : e }
        )
      );
  }

  public voltar() {
    switch (this.login.sistema) {
      case 'contabil':
      case 'controle-interno':
        this.router.navigate(['/contabilidade']);
        break;
      default:
        this.sair();
        break;
    }
  }

  private async validarContratoVencido() {
    let dataFimContrato = this.entidade?.empenho?.contrato?.data_termino
    let dataFimAditamento = this.entidade?.empenho?.contrato?.aditamentos[0]?.data_termino
    let dataLiquidacao = this.entidadeForm.get('data_liquidacao').value

    this.entidade?.empenho?.contrato?.aditamentos.forEach(ad => {
      if (ad.data_termino > dataFimAditamento) {
        dataFimAditamento = ad.data_termino
      }
    });

    if (!dataFimAditamento) dataFimAditamento = dataFimContrato

    if (!this.entidade.id && this.entidade.empenho.contrato
      && (new Date(dataLiquidacao) > new Date(dataFimAditamento) && new Date(dataLiquidacao) > new Date(dataFimContrato))) {
      return new Promise((resolve, reject) => {
        this.confirmationService.confirm({
          header: 'Atenção contrato vencido',
          icon: 'pi pi-exclamation-triangle',
          message:
            `Empenho ${this.entidade.empenho.numero}/${this.entidade?.empenho?.ano} de contrato ${this.entidade.empenho.contrato.numero}
                 vencido em ${new DateFormatPipe().transform(dataFimAditamento ? dataFimAditamento : dataFimContrato, ['local'])}. Deseja continuar?`,
          accept: () => {
            resolve(true);
          },
          reject: () => {
            resolve(false);
          }
        });
      });
    } else { return true; }
  }

  // public salvarLiquidacao() {
  //   if (this.entidade?.empenho?.contrato?.aditamentos?.length > 0) {
  //     const contrato = this.entidade?.empenho?.contrato
  //     let adita
  //     contrato.aditamentos.forEach((item) => {
  //       if (!adita) {
  //         adita = item
  //       } else if (+adita?.valor_total < +item?.valor_total) {
  //         adita = item
  //       }
  //     })
  //     if (new DateFormatPipe().transform(adita?.data_termino, []) < this.entidade?.data_liquidacao) {
  //       this.confirmationService.confirm({
  //         message: `Contrato se encontra vencido (${new DatePipe('pt').transform(adita?.data_termino, 'dd/MM/yyyy')}), deseja continuar?`,
  //         header: 'Atenção contrato vencido',
  //         icon: 'pi pi-exclamation-triangle',
  //         acceptLabel: 'Sim',
  //         rejectLabel: 'Não',
  //         accept: () => {
  //           this.submitForm();
  //         },
  //         reject: () => {
  //           warning('Liquidação não salva!')
  //         }
  //       });
  //     } else {
  //       this.submitForm();
  //     }
  //   } else {
  //     if (new DateFormatPipe().transform(this.entidade?.empenho?.contrato?.data_termino, []) < this.entidade?.data_liquidacao) {
  //       this.confirmationService.confirm({
  //         message: `Contrato se encontra vencido (${new DatePipe('pt').transform(this.entidade?.empenho?.contrato?.data_termino, 'dd/MM/yyyy')}), deseja continuar?`,
  //         header: 'Atenção contrato vencido',
  //         icon: 'pi pi-exclamation-triangle',
  //         acceptLabel: 'Sim',
  //         rejectLabel: 'Não',
  //         accept: () => {
  //           this.submitForm();
  //         },
  //         reject: () => {
  //           warning('Liquidação não salva!')
  //         }
  //       });
  //     } else {
  //       this.submitForm();
  //     }
  //   }
  // }

  public async calcularRetencoesAliquotas() {
    const favorecido: Favorecido = this.entidadeForm.get('empenho').value?.favorecido

    if (favorecido && (favorecido.simples_nacional || favorecido.terceiro_setor || favorecido.autarquia)) return

    if (this.entidade.parcela == 0 && this.entidade.id ? 'readonly' : null) return

    // Verifica se o calculo deve ser realizado
    if (this.login.parametro.contabil.utilizar_aliquota_ir || this.login.parametro.contabil.utilizar_aliquota_csll || this.login.parametro.contabil.utilizar_aliquota_cofins || this.login.parametro.contabil.utilizar_aliquota_pis_pasep) {
      if (!this.entidadeForm.get('data_vencimento').value) {
        info('Informe a data de vencimento!')
        return;
      }

      this.atualizarBaseIrPorDeducoesReinf();
      const valorBaseIR = this.possuiDeducoesReinf()
        ? this.valorBaseIrPorDeducoesReinf()
        : this.entidadeForm.get('valor_base_ir').value ? this.entidadeForm.get('valor_base_ir').value : this.entidade.valor_base_ir
      const valorBaseCSLL = this.entidadeForm.get('valor_base_csll').value ? this.entidadeForm.get('valor_base_csll').value : this.entidade.valor_base_csll
      const valorBaseCOFINS = this.entidadeForm.get('valor_base_cofins').value ? this.entidadeForm.get('valor_base_cofins').value : this.entidade.valor_base_cofins
      const valorBasePIS = this.entidadeForm.get('valor_base_pis').value ? this.entidadeForm.get('valor_base_pis').value : this.entidade.valor_base_pis
      const valorLiquidacao = this.entidadeForm.get('valor_liquidado').value ? this.entidadeForm.get('valor_liquidado').value : this.entidade.valor_liquidado
      const empenho: EmpenhoResto = this.entidadeForm.get('empenho').value ? this.entidadeForm.get('empenho').value : this.entidade.empenho

      if ((valorBaseIR > valorLiquidacao) || (valorBaseCSLL > valorLiquidacao) || (valorBaseCOFINS > valorLiquidacao) || (valorBasePIS > valorLiquidacao)) {
        warning('O valor da base de calculo não pode ser maior que o Valor da Liquidação.<br>Por favor, revise e tente novamente!')
        return;
      }

      const exeEmpPai: Exercicio = await this.exercicioService.obter({ ano: empenho.ano }).toPromise()

      this.compra = await this.compraService.obter({ 'empenho_resto.id': empenho.id, excluido: false, 'orgao_id': this.login.orgao.id, 'exercicio_id': exeEmpPai.id, relations: 'empenho_resto,itens.produto_unidade.produto.aliquota,itens.produto_unidade.produto.material.aliquota' }).toPromise()

      // Busca nos itens da compra a primeira aliquota que encontrar
      let aliquota: Aliquota
      for (const item of this.compra.itens) {
        if (item.produto_unidade.produto?.aliquota) {
          aliquota = item.produto_unidade.produto?.aliquota
          break;
        } else if (item.produto_unidade.produto?.material?.aliquota) {
          aliquota = item.produto_unidade.produto?.material?.aliquota
          break;
        }
      }

      // Verifica se todos os itens da compra estão na mesma aliquota
      if (aliquota) {
        const aliquotaDiferente = this.compra.itens.filter(item => {
          if (item.produto_unidade.produto?.aliquota) {
            if (item.produto_unidade.produto?.aliquota.id !== aliquota.id) return item
          } else if (item.produto_unidade.produto?.material?.aliquota) {
            if (item.produto_unidade.produto?.material?.aliquota.id !== aliquota.id) return item
          }
        });

        if (aliquotaDiferente.length > 0) {
          // se tem mais de uma aliquota, abre o modal para selecionar as quantidades dos itens
          $('#dlgItensCompra').modal('show')

          this.possuiDeducoesReinf() ? this.atualizarBaseIrPorDeducoesReinf() : this.entidadeForm.get('valor_base_ir').setValue(null)
          this.entidadeForm.get('valor_base_csll').setValue(null)
          this.entidadeForm.get('valor_base_cofins').setValue(null)
          this.entidadeForm.get('valor_base_pis').setValue(null)

          info('Não foi possível gerar retenções automaticamente.<br>Itens da compra possui mais de um tipo de aliquota cadastrada.<br>Informe as quantidades dos itens recebidos para calcular automaticamente!');
          return;
        }
      } else {
        info('Não foi possível gerar retenções automaticamente.<br>Não foi encontrado alíquota vinculada aos itens da compra.');
        return;
      }

      if (this.login.parametro.contabil.utilizar_aliquota_ir) {
        const baseIrCalculo = this.possuiDeducoesReinf() ? this.valorBaseIrPorDeducoesReinf() : (valorBaseIR ? valorBaseIR : valorLiquidacao);
        this.entidadeForm.get('valor_base_ir').setValue(`${baseIrCalculo}`)
        this.calcularRetencao(baseIrCalculo, aliquota.ir, 'IR')
      }

      if (this.login.parametro.contabil.utilizar_aliquota_csll) {
        this.entidadeForm.get('valor_base_csll').setValue(valorBaseCSLL ? valorBaseCSLL : valorLiquidacao)
        this.calcularRetencao(valorBaseCSLL ? valorBaseCSLL : valorLiquidacao, aliquota.csll, 'CSLL')
      }

      if (this.login.parametro.contabil.utilizar_aliquota_cofins) {
        this.entidadeForm.get('valor_base_cofins').setValue(valorBaseCOFINS ? valorBaseCOFINS : valorLiquidacao)
        this.calcularRetencao(valorBaseCOFINS ? valorBaseCOFINS : valorLiquidacao, aliquota.cofins, 'COFINS')
      }

      if (this.login.parametro.contabil.utilizar_aliquota_pis_pasep) {
        this.entidadeForm.get('valor_base_pis').setValue(valorBasePIS ? valorBasePIS : valorLiquidacao)
        this.calcularRetencao(valorBasePIS ? valorBasePIS : valorLiquidacao, aliquota.pis_pasep, 'PIS')
      }
    }
  }

  public async calcularRetencao(valor: number, aliquotaValor: number, aliquotaNome: 'IR' | 'CSLL' | 'COFINS' | 'PIS') {
    const tipoFavorecido = this.entidade.empenho.favorecido.tipo.nome === 'CPF - PESSOA FÍSICA' ? 'PF' : this.entidade.empenho.favorecido.tipo.nome === 'CNPJ - PESSOA JURÍDICA' ? 'PJ' : ''

    let fichaExtra: FichaExtra = await this.fichaExtraService.obter({ exercicio_id: this.login.exercicio.id, orgao_id: this.login.orgao.id, retencao: true, excluida: false, 'ficha.tipo_imposto': `${aliquotaNome}`, 'ficha.tipo_favorecido': tipoFavorecido, relations: 'plano,favorecido,ficha' }).toPromise()
    let fichaExtraAutarquia: FichaExtra = await this.fichaExtraService.obter({ exercicio_id: this.login.exercicio.id, orgao_id: this.login.orgao.id, retencao: true, excluida: false, tipo_imposto: `${aliquotaNome}`, tipo_favorecido: tipoFavorecido, relations: 'plano,favorecido' }).toPromise()

    if (!fichaExtra) {
      fichaExtra = await this.fichaExtraService.obter({ exercicio_id: this.login.exercicio.id, orgao_id: this.login.orgao.id, retencao: true, excluida: false, 'ficha.tipo_imposto': `${aliquotaNome}`, 'ficha.tipo_favorecido$null': 'true', relations: 'plano,favorecido,ficha' }).toPromise()
    }

    if (!fichaExtra && !fichaExtraAutarquia) {
      fichaExtraAutarquia = await this.fichaExtraService.obter({ exercicio_id: this.login.exercicio.id, orgao_id: this.login.orgao.id, retencao: true, excluida: false, tipo_imposto: `${aliquotaNome}`, 'tipo_favorecido$null': 'true', relations: 'plano,favorecido,ficha' }).toPromise()
    }

    const retencaoIgual = this.listaRetencoes.find(item => item.ficha?.id === fichaExtra?.id || item.ficha?.id === fichaExtraAutarquia?.id)

    if (!fichaExtra && !fichaExtraAutarquia) {
      info(`Não foi possível gerar retenção para ${aliquotaNome}.`, 'Ficha não encontrada')
      return;
    }

    if (retencaoIgual) return

    const retencao = new RetencaoResto()
    retencao.valor_retido = +valor * (+aliquotaValor / 100)
    retencao.ficha = fichaExtra ? fichaExtra : fichaExtraAutarquia;
    retencao.liquidacao = this.entidade
    retencao.data_vencimento = this.entidadeForm.get('data_vencimento').value
    retencao.anulado = false
    retencao.editavel = false
    retencao['salvo'] = false

    if (aliquotaNome === 'IR') {
      retencao.base_IR = +valor
      retencao.valor_IR = +valor * (+aliquotaValor / 100)
    } else if (aliquotaNome === 'CSLL') {
      retencao.base_csll = +valor
      retencao.valor_csll = +valor * (+aliquotaValor / 100)
    } else if (aliquotaNome === 'COFINS') {
      retencao.base_cofins = +valor
      retencao.valor_cofins = +valor * (+aliquotaValor / 100)
    } else if (aliquotaNome === 'PIS') {
      retencao.base_pp = +valor
      retencao.valor_pp = +valor * (+aliquotaValor / 100)
    }

    this.listaRetencoes.push(retencao)
  }

  public baseRetencoes(retencoes: { valorBase: number; ir: number; csll: number; cofins: number; pis: number; }) {
    const valorLiquidacao: number = this.entidadeForm.get('valor_liquidado').value ? this.entidadeForm.get('valor_liquidado').value : this.entidade.valor_liquidado

    if (+retencoes.valorBase.toFixed(2) > valorLiquidacao) {
      warning(`As quantidades selecionada ultrapassam o Valor Total da Liquidação (${this.funcaoService.formatarMoedaPtBr(valorLiquidacao)}).<br>Por favor, revise e tente novamente!`)
      return;
    }

    $('#dlgItensCompra').modal('hide')

    if (this.login.parametro.contabil.utilizar_aliquota_ir) {
      const baseIrCalculo = this.possuiDeducoesReinf() ? this.valorBaseIrPorDeducoesReinf() : retencoes.valorBase;
      this.entidadeForm.get('valor_base_ir').setValue(`${baseIrCalculo}`)
      this.calcularRetencao(baseIrCalculo, (retencoes.ir / retencoes.valorBase) * 100, 'IR')
    }

    if (this.login.parametro.contabil.utilizar_aliquota_csll) {
      this.entidadeForm.get('valor_base_csll').setValue(retencoes.valorBase + '')
      this.calcularRetencao(retencoes.valorBase, (retencoes.csll / retencoes.valorBase) * 100, 'CSLL')
    }

    if (this.login.parametro.contabil.utilizar_aliquota_cofins) {
      this.entidadeForm.get('valor_base_cofins').setValue(retencoes.valorBase + '')
      this.calcularRetencao(retencoes.valorBase, (retencoes.cofins / retencoes.valorBase) * 100, 'COFINS')
    }

    if (this.login.parametro.contabil.utilizar_aliquota_pis_pasep) {
      this.entidadeForm.get('valor_base_pis').setValue(retencoes.valorBase + '')
      this.calcularRetencao(retencoes.valorBase, (retencoes.pis / retencoes.valorBase) * 100, 'PIS')
    }
  }

  private getVinculoPreLiquidacao(preLiquidacoes: IPreLiquidacaoExtendido[]) {
    //entrontra as pre liquidações que possuem o mesmo valor que a liquidação
    const preLiquidacaoValorIgual = preLiquidacoes.filter((pre) => +(+pre?.valor_liquidado + +pre?.total_anulado) === +this.entidadeForm.get('valor_liquidado').value);

    if (preLiquidacaoValorIgual?.length === 1) { // se encontrar apenas uma vincula ela
      this.entidadeForm.get('preliquidacao').setValue(preLiquidacaoValorIgual[0]);
      return;
    } else if (preLiquidacaoValorIgual?.length > 1) { // se encontrar mais de uma com o mesmo valor tenta procurar pelo documento
      const preLiquidacaoDocumentoIgual = this.validaDocumentoIgual(preLiquidacaoValorIgual);
      if (preLiquidacaoDocumentoIgual) { //encontrou documento igual
        this.entidadeForm.get('preliquidacao').setValue(preLiquidacaoDocumentoIgual);
        return;
      } else { // se nao encontrar o documento igual vincul a com valor igual com menor ID.
        this.entidadeForm.get('preliquidacao').setValue(preLiquidacaoValorIgual[0]);
        return;
      }
    }
  }

  private validaDocumentoIgual(preLiqs: PreLiquidacaoResto[]): PreLiquidacaoResto | undefined {
    let documento: string = this.entidadeForm.get('documento').value; // doc normal do valor digitado
    let doc = this.entidadeForm.get('documento').value.replace(/^(0+)(\d)/g, "$2"); // sem os zeros a esquerda
    let docZero: string = doc;
    let docPonto: string = this.entidadeForm.get('documento').value;

    docPonto = docPonto.split('.').join(''); // valor do input digitado sem os pontos
    let docPontoZero = docPonto.split('.').join('').replace(/^(0+)(\d)/g, "$2"); // sem os pontos e sem os zeros
    let docZeroPonto = this.entidadeForm.get('documento').value.split('.').join('').replace(/^(0+)(\d)/g, "$2").trim(); // sem espaços desnecessarios

    const documentoLiq = [documento, docPontoZero, docZero, docPonto, docZeroPonto];

    const documentosIguais = []
    for (const pre of preLiqs) {
      let documento: string = pre?.documento; // doc normal do valor digitado
      let doc = pre.documento?.replace(/^(0+)(\d)/g, "$2"); // sem os zeros a esquerda
      let docZero: string = doc;
      let docPonto: string = pre?.documento;

      docPonto = docPonto?.split('.')?.join(''); // valor do input digitado sem os pontos
      let docPontoZero = docPonto?.split('.')?.join('')?.replace(/^(0+)(\d)/g, "$2"); // sem os pontos e sem os zeros
      let docZeroPonto = pre?.documento?.split('.')?.join('')?.replace(/^(0+)(\d)/g, "$2")?.trim(); // sem espaços desnecessarios

      const documentoPre = `${documento},${docPontoZero},${docZero},${docPonto},${docZeroPonto}`;

      for (const docLiq of documentoLiq) {
        if (documentoPre.includes(docLiq)) {
          documentosIguais.push(pre);
          break;
        }
      }
    }

    const preSelecionada = documentosIguais?.[0];

    return preSelecionada;
  }

}
